import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { UmsService } from '../ums.service';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'app-transfer-scrutiny',
  templateUrl: './transfer-scrutiny.component.html',
  styleUrls: ['./transfer-scrutiny.component.scss']
})
export class TransferScrutinyComponent implements OnInit {
  TclcScrutiny: FormGroup;
  SearchForm: FormGroup;
  submitpayload: any;
  submitButton = true;
  editButton = false;
  showSubmitButton = true;
  Table = false;
  APIService: any;
  dialogRef: MatDialogRef<any>;
  dialogRef1: MatDialogRef<any>;
  sessionList: any[];
  SessionFilterList: any[];
  sessionId = 0;
  CoCode = 0;
  CgCode = 0;
  collegeList: any;
  CertList: any;
  filteredCertList: any;
  TclcData: any;
  SessionNo: any;
  userPermission: any;
  Incoming: boolean;
  TclcIncoming: any;
  pageSize = 100;
  pageSizeOptions: number[] = [150,200,300,400,500];
  currentPage = 1;
  totalItems = 0;
  calledApi = 0; // Total number of APIs called
  finishedApi = 0; // Total number of APIs completed (success or failure)
  setIntervalSearch: any;
  // jsonData: any;
  pageIndex = 0; // default to 0
  // FeeAppStatus: string = 'Fees Paid';

  constructor(private dialog: MatDialog,
    public umsService: UmsService,
    private modalPopupService: ModalpopService,
    private fb: FormBuilder, public router: Router, private httpClient: HttpClient,
    private spinner: NgxSpinnerService
  ) { this.APIService = environment.serviceUrl; }


  ngOnInit(): void {
    const storedFeeAppStatus = sessionStorage.getItem('FeeAppStatus');

      this.TclcScrutiny = this.fb.group({
      CertType: new FormControl('All'),
      FeeAppStatus: new FormControl(
      storedFeeAppStatus !== null ? storedFeeAppStatus : 'Fees Paid'
  ),
    });
    this.SearchForm = this.fb.group({
      SearchString: new FormControl('')
    })

    const storedPageIndex = JSON.parse(localStorage.getItem('pageIndex') || '0');
    this.pageIndex = storedPageIndex;
    this.currentPage = storedPageIndex + 1;

    if (JSON.parse(sessionStorage.getItem("session")) == null) {
      this.fetchSecretData();
    }
    else if (JSON.parse(sessionStorage.getItem("session")) != null) {
      let sessionData = JSON.parse(sessionStorage.getItem("session"));
      this.SessionNo = sessionData.SnNo
      this.spinner.show();
      this.fetchCertType()
      this.ShowTable()
      // this.keypress()
    }
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    this.Table = false;
    this.sessionId = 0;
    this.CoCode = 0;
    this.CgCode = 0;
    let id = ''
    this.submitButton = true;
    this.editButton = false;
  }

  fetchSecretData() {
    this.umsService.getSecretData().subscribe((res) => {
      this.SessionNo = res.projectPharam['SnNo'];
      this.spinner.show();
      this.fetchCertType()
      this.ShowTable()
      // this.keypress()
    }
    );
  }


  fetchCertType() {
    this.calledApi++
    const payload = {};
    payload['CdType'] = 'TCLC';
    this.umsService.fetchCodeType(payload).subscribe((res) => {
      if (res.status) {

        this.CertList = res.data;
        this.filteredCertList = this.CertList.slice();
        this.finishedApi++;
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      } else {
        this.finishedApi++;
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      }
    }, (ERROR: HttpErrorResponse) => {
      this.finishedApi++;
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    });
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex; // <-- capture the page index
    this.currentPage = this.pageIndex + 1;

    localStorage.setItem('pageNo', JSON.stringify(this.currentPage));
    localStorage.setItem('pageIndex', JSON.stringify(this.pageIndex)); // <-- save it
    this.ShowTable();
    this.keypress();
  }

  ShowTable() {
    console.log(this.currentPage, 'page no');
    // this.spinner.show(); 
    this.calledApi++
    const payload = {};
    payload['SessionId'] = this.SessionNo;
    payload['CertType'] = this.TclcScrutiny === undefined ? 'ALL' : this.TclcScrutiny.value['CertType']
    payload['PageSize'] = this.pageSize;
    payload['PageNumber'] = localStorage.getItem('pageNo') ? localStorage.getItem('pageNo') : this.currentPage;
    payload['IsStudent'] = 0;
    payload['StuId'] = 0;
    payload['CertStatus'] = this.TclcScrutiny.get('FeeAppStatus').value;
    this.spinner.show();
    this.umsService.GetTclcData(payload).subscribe((res) => {
      if (res.status) {
        // this.spinner.show();  
        console.log('res of tclc', res.data);
        this.totalItems = res.data[0].TotalCount;
        if (this.userPermission[0].CgUi == 'C') {
          console.log('im college user');
          console.log('college is', this.userPermission[0].CgId);

          this.TclcData = res.data.filter(record => record.StuCollege == this.userPermission[0].CgId);
          this.TclcIncoming = res.data.filter(record => record.DestClg == this.userPermission[0].CgId && record.CertType != 'ADMC' && record.FeeStatus == 'Y');
          if (this.TclcData.length != 0 && this.TclcIncoming.length != 0) {
            this.Table = true;

          }
          else if (this.TclcData.length != 0 && this.TclcIncoming.length == 0) {
            this.Table = true;
            this.Incoming = false;
          }
          else if (this.TclcData.length == 0 && this.TclcIncoming.length != 0) {
            this.Table = false;
            this.Incoming = true;
          }
          else if (this.TclcData.length == 0 && this.TclcIncoming.length == 0) {
            this.Table = false;
            this.Incoming = false;
          }

          // this.spinner.hide()
        }
        else {
          this.TclcData = res.data.filter(record => {
       // console.log('CertStatus:',record.CertStatus,'Selected:',this.FeeAppStatus);
          const status = this.TclcScrutiny.get('FeeAppStatus').value;
          return status === '' || record.CertStatus === status;
      });
          this.Incoming = false;
          if (this.TclcData.length == 0) {
            this.Table = false;
          }
          else {
            this.Table = true;
          }
        }
        // this.Table = true
        this.finishedApi++;
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }

      }
      else {
        this.Table = false;
        this.finishedApi++;
        if (this.finishedApi === this.calledApi) {
          this.spinner.hide();
        }
      }
    }, (ERROR: HttpErrorResponse) => {
      this.Table = false;
      this.finishedApi++;
      if (this.finishedApi === this.calledApi) {
        this.spinner.hide();
      }
    });

  }

  onFeeAppStatusChange(status: string) {
  // console.log('Selected Fee/App Status:', status);
  this.TclcScrutiny.get('FeeAppStatus').setValue(status);
  sessionStorage.setItem('FeeAppStatus', status);
  this.ShowTable();
}

  getStatus(tclc: any): string {
    let status = '';

    switch (tclc['CertStatus']) {
      case "APR":
        if (tclc['CertType'] == "ADMC") {
          status = tclc['RgStatus'] == "L" ? 'Application Approved' : 'Application InProcess';
        } else {
          status = 'Certificate Generated';
        }
        break;

      case "APPAP":
        if (tclc['CertType'] == "ADMC") {
          status = tclc['RgStatus'] == "L" ? 'Application Approved' : 'Application InProcess';
        } else {
          status = 'Application Approved';
        }
        break;

      case "REJ":
        status = 'Rejected';
        break;

      case "Submitted":
        status = 'Submitted';
        break;

      case "ReSubmitted":
        status = 'Re-Submitted';
        break;
      case "REC":
        status = "Rectify"
        break;
      default:
        status = tclc['CertStatus'];
        break;
    }

    return status;
  }

  getRequest(tclc: any): string {
    let type = '';

    switch (tclc['CertType']) {
      case "MC":
        type = 'Migration Certificate'
        break;
      case "TC":
        type = "Transfer Certificate"
        break;
      case "LC":
        type = "Leaving Certificate"
        break;
      case "ADMC":
        type = "Admission Cancellation"
        break;
      case "TS":
        type = "Transcript Certificate"
        break;
      case "PC":
        type = "Provisional Passing Certificate"
        break;
      case "OPC":
        type = "Original Passing Certificate"
        break;
      case "RC":
        type = "Rank Certificate"
        break;
      default:
        type = tclc['CertType'];
        break;
    }

    return type;
  }

  redirect(to): void {
    this.router.navigate([to]);
  }

  details(data) {
    console.log('data i send', data);

    this.umsService.setTclcData(data);
    this.redirect('TclcApproval')
  }

  keypress() {
    if (this.setIntervalSearch) {
      clearTimeout(this.setIntervalSearch);
    }
    this.setIntervalSearch = setTimeout(() => {
      let payload = {}
      payload['SearchString'] = this.SearchForm.value['SearchString'];
      payload['SessionId'] = this.SessionNo;
      payload['CertType'] = this.TclcScrutiny === undefined ? 'ALL' : this.TclcScrutiny.value['CertType']
      payload['PageSize'] = this.pageSize;
      // payload['PageNumber'] = this.currentPage;
      payload['IsStudent'] = 0;
      payload['StuId'] = 0;
      payload['CertStatus'] = this.TclcScrutiny.get('FeeAppStatus').value;
      // payload['PageNumber'] = this.currentPage;
      if (payload['SearchString'] === "") {
        payload['PageNumber'] = localStorage.getItem('pageNo') ? localStorage.getItem('pageNo') : this.currentPage;
      } else {
        payload['PageNumber'] = 1;
      }
      this.umsService.GetTclcData(payload).subscribe((res) => {
        if (res.status) {
          // this.spinner.show();  
          console.log('res of tclc', res.data);
          this.totalItems = res.data[0].TotalCount;
          if (this.userPermission[0].CgUi == 'C') {
            console.log('im college user');
            console.log('college is', this.userPermission[0].CgId);

            this.TclcData = res.data.filter(record => record.StuCollege == this.userPermission[0].CgId);
            this.TclcIncoming = res.data.filter(record => record.DestClg == this.userPermission[0].CgId && record.CertType != 'ADMC' && record.FeeStatus == 'Y');
            if (this.TclcData.length != 0 && this.TclcIncoming.length != 0) {
              this.Table = true;

            }
            else if (this.TclcData.length != 0 && this.TclcIncoming.length == 0) {
              this.Table = true;
              this.Incoming = false;
            }
            else if (this.TclcData.length == 0 && this.TclcIncoming.length != 0) {
              this.Table = false;
              this.Incoming = true;
            }
            else if (this.TclcData.length == 0 && this.TclcIncoming.length == 0) {
              this.Table = false;
              this.Incoming = false;
            }

            // this.spinner.hide()
          }
          else {
            console.log('im university user');
            // this.TclcData = res.data
            this.TclcData = res.data.filter(record => record.FeeStatus == 'Y');
            this.Incoming = false;
            if (this.TclcData.length == 0) {
              this.Table = false;

            }
            else {
              this.Table = true;
            }
            // this.spinner.hide()
          }
          this.Table = true

          this.spinner.hide();

        }
        else {
          this.Table = false;

          this.spinner.hide();
        }
      }, (ERROR: HttpErrorResponse) => {
        this.Table = false;

        this.spinner.hide();
      })
    }, 1000)

  }

}

